// (function(){
// 	'use strict';
// 	angular
// 	.module('myApp')
// 	.directive('autocomplete', ['$uibModal', '$http' , '$log', '$q', function($uibModal, $http, $log, $q){
// 		return {
// 			restrict : 'CA',
// 			scope: {
// 				ngModel : '=ngModel',
// 				// source : '=source'
// 			},
// 			require: 'ngModel',
// 			link: function (scope, element, attrs, ngModelCtrl) {
// 				if(ngModelCtrl)
// 				{
// 					ngModelCtrl.$setViewValue('');
// 				}
// 				element.autocomplete({
// 					serviceUrl: attrs.url,
// 					onSelect : function(data){
// 						scope.ngModel = data.dataId;
// 					}
// 				});
// 			}
// 		};
// 	}]);
// })();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('convertToNumber', function() {
		// usage: 'convert-to-number'=>'', convert-to-number
		return {
			require: 'ngModel',
			link: function(scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function(val) {
					return parseInt(val, 10);
				});
				ngModel.$formatters.push(function(val) {
					return '' + val;
				});
			}
		};
	});
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('dateTimePicker',function () {
		// USAGE: ['date-time-picker'=>'','data-hasTime'=>true] or date-time-picker data-hastime="true" 
		var defaultDateTimeViewFormat = 'MM/DD/YYYY hh:mm A';
		var defaultDateTimeModelFormat = 'YYYY-MM-DD HH:mm:ss';
		var defaultDateViewFormat = 'MM/DD/YYYY';
		var defaultDateModelFormat = 'YYYY-MM-DD';
		return {
			restrict: 'A',
			require: '?ngModel',
			scope: {
				ngModel: '='
			},
			link: function (scope, element, attributes, ngModelCtrl) {
				var model = attributes['ngModel'];
				// update the scope if model is defined
				if (model) {
					scope[model] = 'bar';
				}

				var dateFormat = '';
				var viewFormat = '';
				if(attributes.hastime != undefined){
					var dateFormat = (attributes.format != undefined) ? attributes.format : defaultDateTimeModelFormat;
					var viewFormat = (attributes.formathuman != undefined) ? attributes.formathuman : defaultDateTimeViewFormat;
				}else{
					var dateFormat = (attributes.format != undefined) ? attributes.format : defaultDateModelFormat;
					var viewFormat = (attributes.formathuman != undefined) ? attributes.formathuman : defaultDateViewFormat;
				}
				element.addClass('relativity');
				element.datetimepicker({
					format: viewFormat,
					stepping: 15,
				});
				var picker = element.data("DateTimePicker");

				ngModelCtrl.$formatters.push(function (value) {
					if (value == undefined) {
						return '';
					}
					var date = moment(value);
					if (date.isValid()) {
						return date.format(viewFormat);
					}
					return '';
				});

				element.on('dp.hide', function (event) {
					scope.$apply(function() {
						var date = picker.date();
						ngModelCtrl.$setViewValue(date.format(dateFormat));
					});
				});
			}
		};
	});
})();


(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('dynamicNgModel', ['$compile', '$parse', function ($compile, $parse) {
		// usage: dynamic-ng-model="'clientsCtrl.searchQry.'+column.field" 
		return {
			restrict: 'A',
			terminal: true,
			priority: 100000,
			link: function (scope, elem) {
				var name = $parse(elem.attr('dynamic-ng-model'))(scope);
				elem.removeAttr('dynamic-ng-model');
				elem.attr('ng-model', name);
				$compile(elem)(scope);
			}
		};
	}]);
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('fileModel', ['$parse', function ($parse) {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				var model = $parse(attrs.fileModel);
				var modelSetter = model.assign;

				element.bind('change', function(){
					scope.$apply(function(){
						modelSetter(scope, element[0].files);
					});
				});
			}
		};
	}]);
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('icheck', function() {
		return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			// $('input').iCheck();
			element.iCheck({
				checkboxClass: "icheckbox_flat"
			});
		}
	  };
	})
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('metis', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				if (scope.$last == true) {
					$timeout(function () {
						$('#side-menu').metisMenu();
					}, 250)
				}

			}
		};
	}]);
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.directive('showModal', ['$templateCache', '$uibModal', '$http' , '$log', '$q', '$timeout', function($templateCache, $uibModal, $http, $log, $q, $timeout){
	return {
		restrict : 'CE',
		scope: {
			myItem : '=item',
			myResultEvent : '@expect',
			myAction : '@action',
			myPayload : '=payload',
			myPrepJob : '@prepjob',
			controller : '@',
			modalsize : '@',
			isFile : '@file'
		},
		link: function (scope, element, attrs) {
			element.removeClass('show_modal');
			element.bind('click', function (e) {
				e.preventDefault();
				scope.openModal(this.href);
				scope.$apply();
			});
			scope.$on('$destroy', function(){
				element.unbind('click');
			});

			scope.openModal = function (url) {
				var modalController = (scope.controller != undefined)?scope.controller:'ModalInstanceController';
				var modalsize = (scope.modalsize != undefined)?scope.modalsize:'md';

				$templateCache.remove(url);

				//Open Modal
				var originalObj = angular.extend({}, scope.myItem);
				var uibModalInstance = $uibModal.open({
					animation: true,
					templateUrl: url,
					controller: modalController,
					controllerAs: 'ctrl',
					backdrop: 'static',
					size: modalsize,
					resolve: {
						items: function () {
							return {
								bind	:	scope.myItem,
								url	 :	url,
								expect	: 	scope.myResultEvent,
								action	:	scope.myAction,
								payload	:	scope.myPayload,
								isFile  :	scope.isFile
							};
						}
					}
				});

				uibModalInstance.rendered.then(function() {

				});
				uibModalInstance.opened.then(function() {
					// alert("OPENED!");
				});
				uibModalInstance.result.then(function (data) {
				}, function () {
					if(scope.myItem != undefined)
					{
						angular.extend(scope.myItem, originalObj);
					}
				});
			};
		}
	};
	}]);
})();


//# sourceMappingURL=_mvmntdirectives.js.map
